import {observable, action} from 'mobx'
import {IQuestionsCategories} from '../types/question'

export class QuestionStore {
  @observable
  questions: IQuestionsCategories[] = []

  @action
  setQuestions(questions: IQuestionsCategories[]) {
    this.questions = questions
  }
}
